import { CiiPredictiveAllowanceModalComponent } from 'src/app/shared/components/cii-predictive-allowance-modal/cii-predictive-allowance-modal.component';
import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ViewChild, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FetchBdnFileComponent } from 'src/app/shared/components/fetch-bdn-file/fetch-bdn-file.component';
import { GenerateEmissionReportComponent } from 'src/app/shared/components/generate-emission-report/generate-emission-report.component';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import {
  getmonths,
  getShipNameOptions,
  gettypeofreport,
  getvesselname,
} from 'src/app/shared/helpers/dropdown-options';
import { CargoheatingCommonService } from 'src/app/shared/service/cargo-heating-service/cargoheating-common.service';
import { EmissionService } from 'src/app/shared/service/emission-service/emission.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

import { Subject, takeUntil } from 'rxjs';
import { DEMO_VESSEL_PC } from 'src/app/shared/helpers/heating-table-dynamic-extract.util';
import { isEmzoilVessel, normalizeEmissionVesselClient } from 'src/app/shared/helpers/emission-client-filter.util';

@Component({
  selector: 'app-cii',
  templateUrl: './cii.component.html',
  styleUrls: ['./cii.component.scss'],
})
export class CiiComponent implements OnInit, AfterViewInit, OnDestroy {
  loadingAllowanceImo: string | null = null;
  isOpeningAllowanceModal: boolean = false;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  myreportForm: FormGroup;
  monthOptions: any;
  shipnameoptions: any;
  vesselnameoptions: any;
  typeofreportoptions: string[];

  paginatedData: any[] = [];
  currentPage: number = 0;
  itemsPerPage: number = 100;

  elements: any[] = [];
  vesselNameSuggestions: any[] = [];

  clientFilters: { [key: string]: (item: any) => boolean } = {
    'Eiger Shipping': (item) => item.client_name === 'Eiger' && !isEmzoilVessel(item),
    'Zeronorth ZN': (item) => item.client_name === 'ZeroNorth',
    'Elite Shipping': (item) =>
      item.client_name === 'Elite' ||
      item.client_name === 'ELITE TANKSHIP DMCC',
    'Bunge Shipping': (item) => item.client_name === 'Bunge',
    'Alcor Shipping': (item) =>
      item.client_name === 'ALCOR CHARTERING DMCC',
    'EMZoil Shipping': (item) =>
      item.client_name === 'EMZ OIL' ||
      item.client_name === 'EMZOIL FZCO' ||
      item.client_name?.toLowerCase().includes('emz') ||
      isEmzoilVessel(item),
    'Ethiopian Shipping & Logistics': (item) =>
      item.client_name?.toLowerCase() === 'ethiopian shipping & logistics',
  };
  clientList: string[] = [];
  allFleetData: any[] = [];

  isLoading: boolean = false;
  selectedReport: string = '';
  // tableData: any[] = [
  //   {
  //     ship_name: 'M/V Ocean Star',
  //     ship_imo: '9876543',
  //     wtw_mass: '14560',
  //     gmg_index: '0.78',
  //     compliance_balance: '-230',
  //     fuel_penalty: '€5200',
  //     voyage_no: 'VOY-102',
  //     ingested_time: new Date()
  //   },
  //   {
  //     ship_name: 'M/V Blue Horizon',
  //     ship_imo: '1234567',
  //     wtw_mass: '13200',
  //     gmg_index: '0.65',
  //     compliance_balance: '120',
  //     fuel_penalty: '€3100',
  //     voyage_no: 'VOY-221',
  //     ingested_time: new Date()
  //   },
  //   {
  //     ship_name: 'M/V Sea Queen',
  //     ship_imo: '7654321',
  //     wtw_mass: '15890',
  //     gmg_index: '0.82',
  //     compliance_balance: '-90',
  //     fuel_penalty: '€4500',
  //     voyage_no: 'VOY-089',
  //     ingested_time: new Date()
  //   },
  //   {
  //     ship_name: 'M/V Ocean Star',
  //     ship_imo: '9876543',
  //     wtw_mass: '14560',
  //     gmg_index: '0.78',
  //     compliance_balance: '-230',
  //     fuel_penalty: '€5200',
  //     voyage_no: 'VOY-102',
  //     ingested_time: new Date()
  //   },
  //   {
  //     ship_name: 'M/V Blue Horizon',
  //     ship_imo: '1234567',
  //     wtw_mass: '13200',
  //     gmg_index: '0.65',
  //     compliance_balance: '120',
  //     fuel_penalty: '€3100',
  //     voyage_no: 'VOY-221',
  //     ingested_time: new Date()
  //   },
  //   {
  //     ship_name: 'M/V Sea Queen',
  //     ship_imo: '7654321',
  //     wtw_mass: '15890',
  //     gmg_index: '0.82',
  //     compliance_balance: '-90',
  //     fuel_penalty: '€4500',
  //     voyage_no: 'VOY-089',
  //     ingested_time: new Date()
  //   }
  // ];

  reportOptions = [
    { label: 'Average Temp Forecast', value: 'avg_temp_forecast' },
    { label: 'Tank Temp Forecast', value: 'tank_temp_forecast' },
    { label: 'Heat Plan', value: 'heat_plan' },
    { label: 'Bunker Report', value: 'bunker_forecast' },
  ];
  username: any;
  private destroy$ = new Subject<void>();
  subusername: any;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private commonService: CargoheatingCommonService,
    private emissionService: EmissionService,

    private router: Router,
    private datePipe: DatePipe,
    private overlayService: OverlapService,
    private requestFormService: RequestFormService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  ) {
    this.myreportForm = this.fb.group({
      vesselname: [''],
      typeofreport: [''],
      vesselIMO: ['', [Validators.pattern('^[0-9]*$')]],
      client: [''],
    });

    this.monthOptions = getmonths();
    this.shipnameoptions = getShipNameOptions();
    this.vesselnameoptions = getvesselname();
    this.typeofreportoptions = gettypeofreport();

    this.paginateData();
  }
  ngOnInit(): void {
    this.username = localStorage.getItem('username') ?? '';
    this.subusername = localStorage.getItem('loginPic') ?? '';
    this.fetchReportTableData();
    this.setupFilterSubscriptions();
  }

  setupFilterSubscriptions(): void {
    this.myreportForm.get('client')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedClient: string) => {
        if (selectedClient && this.clientFilters[selectedClient]) {
          // Filter vessel suggestions based on selected client
          this.vesselNameSuggestions = this.allFleetData.filter(this.clientFilters[selectedClient]);
        } else {
          // Reset to all vessels if "All Clients" or none selected
          this.vesselNameSuggestions = this.allFleetData;
        }

        // Reset the vesselname control to prevent invalid orphan selections
        this.myreportForm.get('vesselname')?.setValue([]);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }

  openFetchBdnPopup(row: any) {
    this.dialog.open(FetchBdnFileComponent, {
      width: '550px',
      data: row,
      disableClose: true,
    });
  }
  openInsideTable(row: any) {
    const imo =
      row.original_vessel_imo ??
      row.imo_number ??
      row.ship_imo ??
      row.imo;
    this.router.navigate(['/E-Bdn-InsideView'], {
      queryParams: {
        id: row.id,
        imo: imo,
      },
    });
  }
  // fetchReportTableData(): void {
  //   this.isLoading = true;

  //   this.commonService.getFinalReportTableData().subscribe(
  //     (data: any) => {
  //       const username = localStorage.getItem('username')?.toLowerCase() || '';
  //       if (username.includes('bunge')) {
  //         this.tableData = data.filter((item: any) => item?.client?.toLowerCase() === 'bunge_sa');
  //       } else {
  //         this.tableData = data;
  //       }
  //       this.isLoading = false;
  //       this.elements = [...this.tableData];
  //       this.paginateData();
  //     },
  //     () => {
  //       this.isLoading = false;
  //     }
  //   );
  // }
  applyClientFilter(sourceData: any[]) {
    const selectedClient = this.myreportForm.get('client')?.value;

    if (this.username === 'Meraki - Operations') {
      if (selectedClient && this.clientFilters[selectedClient]) {
        this.elements = sourceData.filter(this.clientFilters[selectedClient]);
      } else {
        this.elements = sourceData;
      }
    } else if (this.clientFilters[this.username]) {
      this.elements = sourceData.filter(this.clientFilters[this.username]);
    } else {
      this.elements = sourceData;
    }

    if (this.subusername?.toLowerCase() === 'grace') {
      const graceImos = ['9378876', '9399480', '9438406', '9432048'];
      this.elements = this.elements.filter((item: any) =>
        graceImos.includes(String(item.imo_number ?? item.ship_imo ?? item.imo ?? '').trim())
      );
    }
  }

  fetchReportTableData(isInitialFetch = true, params: any = {}): void {
    this.isLoading = true;

    this.emissionService.getCIITableData(params).pipe(takeUntil(this.destroy$)).subscribe(
      (res: any) => {
           let vessels = res?.vessels || [];
           vessels.forEach(normalizeEmissionVesselClient);
        // Restrict Grace user strictly to Suezmax vessels
        if (this.subusername?.toLowerCase() === 'grace') {
          const graceImos = ['9378876', '9399480', '9438406', '9432048'];
          vessels = vessels.filter(
            (item: any) => graceImos.includes(String(item.imo_number ?? item.ship_imo ?? item.imo ?? '').trim())
          );
        }
        vessels = this.filterAndMaskDemoVessels(vessels);
        if (isInitialFetch) {
          this.allFleetData = vessels  || [];
          this.vesselNameSuggestions = this.allFleetData;
          this.clientList = Object.keys(this.clientFilters).filter((clientKey) => {
            return this.allFleetData.some((v) => this.clientFilters[clientKey](v));
          });
        }
        this.applyClientFilter(vessels);

        this.currentPage = 0;
        if (this.paginator) {
          this.paginator.firstPage();
        }
        this.paginateData();

        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        console.error(error);
        this.toastr.error('Failed to load CII table data');
      },
    );
  }

  showDetails(row: any) {
    const imo =
      row.original_vessel_imo ??
      row.imo_number ??
      row.ship_imo ??
      row.imo;
    this.router.navigate(['/E-ciitable', imo]);
  }

  onReportSelect(selectedType: string, row: any) {
    const imo =
      row.original_vessel_imo ??
      row.imo_number ??
      row.ship_imo ??
      row.imo;
    const payload = {
      report_type: selectedType,
      vessel_imo: imo,
      hp_number: row.hp_np,
      voyage_no: row.voyage_no,
    };

    this.commonService.printFinalReport(payload).subscribe(
      (response: any) => {
        this.overlayService.showPdf(response);
      },
      () => {
        this.toastr.info(ToasterMessages.RecordNotFount);
      },
    );
  }

  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    const isAsc = sort.direction === 'asc';

    this.paginatedData = data.sort((a, b) => {
      const valueA = a[sort.active];
      const valueB = b[sort.active];
      if (valueA == null) return isAsc ? -1 : 1;
      if (valueB == null) return isAsc ? 1 : -1;
      return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
    });
  }

  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.elements.slice(
      startIndex,
      startIndex + this.itemsPerPage,
    );
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }

  filterClick() {
    const vesselIMO = this.myreportForm.get('vesselIMO')?.value?.trim() || '';
    const vesselNameVal = this.myreportForm.get('vesselname')?.value;

    let params: any = {};
    if (vesselIMO) params.vesselIMO = vesselIMO;

    if (Array.isArray(vesselNameVal)) {
      const names = vesselNameVal.filter(n => n && n.trim() !== '');
      if (names.length > 0) {
        params.vesselname = names.join(',');
      }
    } else if (vesselNameVal && typeof vesselNameVal === 'string') {
      params.vesselname = vesselNameVal.trim();
    }

    this.fetchReportTableData(false, params);
  }

  downloadClick() {
    const parseDate = (dateString: any) => {
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        return `${date.getDate().toString().padStart(2, '0')}-${(
          date.getMonth() + 1
        )
          .toString()
          .padStart(2, '0')}-${date.getFullYear()}`;
      }
      return '';
    };

    const data = this.paginatedData;

    const csvHeader =
      'S.No,Ship Name,Ship IMO,Report Type,Voyage Month,Ingested Time';

    const csvData = data
      .map((row: any, index: number) => {
        const ingested = row.ingested_time ? parseDate(row.ingested_time) : '';
        return `${index + 1},${row.ship_name},${row.ship_imo},${row.report_type},${row.voyage_month},${ingested}`;
      })
      .join('\n');

    const csvContent = `${csvHeader}\n${csvData}`;

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'final_report_data.csv';
    a.click();
  }

  clearClick() {
    this.myreportForm.reset();
    this.fetchReportTableData();
  }

  goBack() {
    this.router.navigate(['/ch-graph']);
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  filterShipNames(event: any) {
    const input = event.target.value.toLowerCase();
    this.vesselNameSuggestions = this.vesselnameoptions.filter((item: any) =>
      item.ship_name.toLowerCase().includes(input),
    );
  }
  refreshPageData() {
    this.isLoading = true;
    this.fetchReportTableData();
  }

  openGenerateReportPopup(row: any) {
    this.dialog.open(GenerateEmissionReportComponent, {
      width: '560px',
      data: { ...row, reportType: 'CII' },
      disableClose: true,
    });
  }

  printFinalReport(row: any) {
    const imo =
      row.original_vessel_imo ??
      row.imo_number ??
      row.ship_imo ??
      row.imo;
    const payload = {
      vessel_imo: imo,
      voyage_no: row.voyage_no,
    };

    this.commonService.printFinalReport(payload).subscribe(
      (res: any) => {
        this.overlayService.showPdf(res);
      },
      () => {
        this.toastr.error('Report Not Found');
      },
    );
  }
  private isDemoUser(): boolean {
    const username = (localStorage.getItem('username') || '').toLowerCase();
    const loginPic = (localStorage.getItem('loginPic') || '').toLowerCase();
    const subuser = (this.subusername || '').toLowerCase();
    return subuser === 'demo' || loginPic === 'demo' || username === 'meraki - demo' || username.includes('demo');
  }
  
  private filterAndMaskDemoVessels(vessels: any[]): any[] {
    if (!this.isDemoUser()) {
      return vessels;
    }
  
    return (vessels || [])
      .filter((v: any) =>
        DEMO_VESSEL_PC.includes(
          String(v?.imo_number ?? v?.ship_imo ?? '').trim()
        )
      )
      .map((v: any) => {
        const imo = String(
          v?.imo_number ?? v?.ship_imo ?? ''
        ).trim();
  
        const index = DEMO_VESSEL_PC.indexOf(imo);
  
        return {
          ...v,
           original_vessel_imo: v.imo_number,
            original_vessel_name: v.ship_name,
          // Mask vessel name
          vessel_name: `Vessel ${index + 1}`,
          ship_name: `Vessel ${index + 1}`,
          client_name: 'Client 1',
          // Mask IMO
          imo_number: 'xxxxxxx',
          ship_imo: 'xxxxxxx'
        };
      });
  }

  
  isImoLoading(element: any): boolean {
    if (!this.loadingAllowanceImo) return false;
    const imo = String(element?.imo_number ?? element?.imo ?? '').trim();
    return String(this.loadingAllowanceImo).trim() === imo;
  }

    openAllowanceForVessel(row: any): void {
    if (this.dialog.openDialogs.length > 0) return;

    if (row?.predictive_allowance) {
      this.dialog.open(CiiPredictiveAllowanceModalComponent, {
        width: '780px',
        data: {
          status: 'success',
          vessel: {
            imo_number: String(row.imo_number || row.imo),
            vessel_name: row.ship_name || row.vessel_name || `IMO ${row.imo_number || row.imo}`,
            dwt: row.loadline_summer_deadweight_metric_tonnes || 0,
            ship_type: row.type_of_vessel || 'TANKER'
          },
          period: {
            months: 3,
            start_date: new Date(Date.now() - 90 * 86400000).toISOString(),
            end_date: new Date().toISOString()
          },
          ...row.predictive_allowance
        },
        panelClass: 'custom-dialog-container'
      });
      return;
    }

    const imo = String(row?.imo_number ?? row?.imo ?? '').trim();
    if (!imo || this.isOpeningAllowanceModal || this.loadingAllowanceImo) return;

    this.loadingAllowanceImo = imo;
    this.isOpeningAllowanceModal = true;
    this.cdr.detectChanges();

    this.emissionService.getCiiPredictiveAllowance(imo, 3, 0.03).subscribe({
      next: (data) => {
        this.loadingAllowanceImo = null;
        this.isOpeningAllowanceModal = false;
        this.cdr.detectChanges();
        if (data?.status === 'success') {
          this.dialog.open(CiiPredictiveAllowanceModalComponent, {
            width: '780px',
            data: data,
            panelClass: 'custom-dialog-container'
          });
        } else {
          this.toastr.warning(data?.message || 'No allowance data found for this vessel');
        }
      },
      error: (err) => {
        this.loadingAllowanceImo = null;
        this.isOpeningAllowanceModal = false;
        this.cdr.detectChanges();
        this.toastr.error('Failed to calculate predictive allowance');
        console.error(err);
      }
    });
  }
}
